import { Component, input } from '@angular/core';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { FetchError } from '../../interfaces/project-interfaces';

@Component({
  selector: 'app-loader',
  imports: [NgOptimizedImage, NgClass],
  template: `
    @if (showError()) {
      @if (showError()?.status === 404) {
        <div class="text-center py-5 px-3">
          <img
            class="img-fluid"
            ngSrc="../../../../assets/404.svg"
            alt="404"
            width="200"
            height="auto" />
          <br />
          <br />
          The requested {{ errorItem() }} could not be found
        </div>
      }
    } @else {
      <div
        class="text-center"
        [ngClass]="spacingClass()">
        <div
          class="spinner-border"
          role="status">
          <span class="visually-hidden">Loading ...</span>
        </div>
        @if (loadingText()) {
          <p class="mt-3">
            {{ loadingText() }}
          </p>
        }
      </div>
    }
  `,
})
export class LoaderComponent {
  spacingClass = input<string>('p-5');
  loadingText = input<string>();
  showError = input<FetchError | null>();
  errorItem = input<string | null>();
}
